import { HeaderNavigation } from "@accor/ace-ui-core";

export default class MGalleryHeaderNavigation extends HeaderNavigation {
  static CLASS_NAMESPACE = "ace-header-navigation";

  /** @inheritDoc */
  // Constructor function that takes the componentHost parameter
  constructor(componentHost, componentName) {
    // Call the constructor of the parent class (BaseComponent)
    super(componentHost, componentName);
    this.isSubNavClick = false;
  }

  /** @inheritDoc */
  // Initialize Function
  initialize() {
    super.initialize();

    this.HeadElement =
      document.querySelector("main > div > div").firstElementChild;

    if (
      this.HeadElement.classList.contains("immersive-heading") ||
      this.HeadElement.classList.contains("heading-hero")
    ) {
      this.HeadElement.style.marginTop = "0";
    } else {
      this.headerComp = this.componentHost.closest("header");
      this.headerHeight = this.headerComp.offsetHeight;
      this.marginTop;
      if (window.innerWidth >= CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.lg) {
        this.marginTop = 96;
      } else if (
        window.innerWidth >= CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.md
      ) {
        this.marginTop = 80;
      } else if (
        window.innerWidth >= CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.sm
      ) {
        this.marginTop = 64;
      }
      this.HeadElement.style.marginTop = `${this.marginTop}px`;
      this.HeadElement.style.marginTop = `${this.headerHeight + this.marginTop}px`;
    }
    this.aceImage = this.HeadElement.querySelector(".ace-image");
    this.headerComp = this.componentHost.closest("header");
    this.myDiv = this.componentHost.querySelector(
      ".ace-header-navigation__main-container.--jsfied",
    );
    this.componentHost
      .querySelector("#ace-burger-menu")
      ?.addEventListener(CoreJS.DomEventConstants.CLICK, () => {
        if (this.myDiv.classList.contains("show")) {
          document
            .querySelector(".ace-quick-access-component-v2 .cmp-filter")
            ?.classList?.add("mob-sticky");
        } else {
          document
            .querySelector(".ace-quick-access-component-v2 .cmp-filter")
            ?.classList?.remove("mob-sticky");
        }
        if (
          window.innerWidth < CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.lg &&
          window.innerWidth > CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.md
        ) {
          document.querySelector("#panel-0").classList.add("showPanel");
        }
      });

    this.posContainer = this.componentHost.querySelector(
      ".ace-header-navigation__pos-container",
    );

    this.headerBlur();
    this.handleSubMenuBtn();

    this.geoAndCurrencyBtns = this.menuMainContainer?.querySelectorAll(
      ".ace-geolocation-selector__button, .ace-currency-selector__button",
    );
    this.geoAndCurrencyBtns?.forEach((button) => {
      button.addEventListener(CoreJS.DomEventConstants.CLICK, (e) => {
        this.posContainer?.classList?.add("appear-on-top");
      });
    });
  }

  handleAnchorTracking() {
    // disable useless tracking layer implemented in ace-frontend
  }

  headerBlur() {
    if (
      this.aceImage?.getAttribute("data-loaded") == "true" ||
      this.HeadElement.querySelector(".content-wrapper")
    ) {
      this.headerComp?.classList?.add("HeaderInverse");
      window.addEventListener(CoreJS.DomEventConstants.SCROLL, () => {
        if (this.HeadElement.getBoundingClientRect().bottom <= 0) {
          this.headerComp?.classList?.remove("HeaderInverse");
        } else {
          this.headerComp?.classList?.add("HeaderInverse");
        }
      });
    }
  }

  handleSubMenuBtn() {
    this.loginConnectBtn?.addEventListener(
      CoreJS.DomEventConstants.CLICK,
      () => {
        this.closeSubMenuDropdownPanelHanlder();
        this.loginConnectPanelCloseBtn = this.componentHost.querySelector(
          `.${HeaderNavigation.CLASS_NAMESPACE}__loginconnect .login-nav__item--close__button`,
        );
        this.loginConnectPanelCloseBtn?.blur();
      },
    );
  }

  subMenuBtnHandler() {
    // copy/paste from ace-frontend and cleaned of its intricated useless tracking layer
    this.btnSubMenu?.forEach((button) => {
      button.addEventListener(CoreJS.DomEventConstants.CLICK, (e) => {
        this.ariaControls = e.currentTarget?.getAttribute("aria-controls");
        if (
          e.currentTarget.classList.contains("activeBtn") &&
          this.menuMainContainer
            ?.querySelector(`#${this.ariaControls}`)
            ?.classList.contains("showPanel")
        ) {
          this.closeSubMenuDropdownPanelHanlder();
          this.isSubNavClick = false;
        } else {
          this.openSubMenuDropdownPanelHandler(e);
          this.isSubNavClick = true;
        }
      });
    });

    this.loginConnectBtn?.addEventListener(
      CoreJS.DomEventConstants.CLICK,
      () => {
        this.closeSubMenuDropdownPanelHanlder();
        this.loginConnectPanelCloseBtn = this.componentHost.querySelector(
          `.${HeaderNavigation.CLASS_NAMESPACE}__loginconnect .login-nav__item--close__button`,
        );
        this.loginConnectPanelCloseBtn?.focus();
      },
    );
  }

  subMoreMenuBtnHandler() {
    // copy/paste from ace-frontend and cleaned of its intricated useless tracking layer
    const secondaryBtn = this.secondary?.querySelectorAll(
      ".link-navigation__sub-more-items > button.link-navigation__menu__link",
    );
    secondaryBtn?.forEach((button, i) => {
      this.ariaSubControls = button.getAttribute("aria-controls");
      if (this.ariaSubControls) {
        button?.setAttribute(
          "aria-controls",
          `more-${this.ariaSubControls + i}`,
        );
      }
      button.addEventListener(CoreJS.DomEventConstants.CLICK, (e) => {
        this.ariaControls = e.currentTarget?.getAttribute("aria-controls");
        if (
          e.currentTarget.classList.contains("activeMoreBtn") &&
          this.secondaryPanel
            ?.querySelector(`#${this.ariaControls}`)
            ?.classList.contains("showMorePanel")
        ) {
          this.closeSubMoreMenuDropdownPanelHanlder();
        } else {
          this.openSubMoreMenuDropdownPanelHandler(e);
        }
      });
    });
    const secondaryPanel = this.secondaryPanel?.querySelectorAll(
      ".link-navigation__panel",
    );
    secondaryPanel?.forEach((panel, i) => {
      this.ariaSubPanelId = panel ? panel.id : "";
      if (this.ariaSubPanelId) {
        panel?.setAttribute("id", `more-${this.ariaSubPanelId + i}`);
        const panelContainer = panel?.querySelectorAll(".cmp-container");
        panelContainer?.forEach((container) => {
          if (container && container.id) {
            container?.removeAttribute("id");
          }
        });
      }
    });
  }

  closeSubMenuDropdownPanelHanlder() {
    this.closeSubMoreMenuDropdownPanelHanlder();
    this.navigationPanel?.forEach((panel) => {
      if (panel?.classList.contains("showPanel")) {
        this.getId = panel.id;
        panel.classList?.remove("showPanel");
        panel.setAttribute("aria-hidden", true);
        // enabling scroll in mobile menu when subpanel is closed
        if (window.innerWidth < HeaderNavigation.BREAK_POINTS) {
          this.menuMainContainer.style.overflowY = "auto";
          this.menuMainContainer.style.overflowX = "hidden";
        }
        this.getActiveBtn = this.menuMainContainer?.querySelector(
          `[aria-controls=${this.getId}]`,
        );
        if (this.getActiveBtn?.classList.contains("activeBtn")) {
          this.getActiveBtn?.classList.remove("activeBtn");
          if (window.innerWidth >= HeaderNavigation.BREAK_POINTS) {
            this.header?.classList.remove("ace-toggleNavbar--open");
          }
          this.getActiveBtn?.setAttribute("aria-expanded", false);
          this.getActiveBtn?.focus();
        }
        //set default image if exists
        const defaultImage = panel
          .querySelector(".ace-nav-panel-product__content")
          ?.getAttribute("data-image");
        if (defaultImage) {
          const imageContainer = panel.querySelector(
            ".ace-nav-panel-product__image",
          );
          imageContainer?.style.setProperty(
            "--nav-panel-product-background-image",
            `url("${defaultImage}")`,
          );
        }
      }
    });
    if (
      !this.isSubNavClick &&
      window.innerWidth <= CoreJS.ResponsiveConstants.GRID_BREAKPOINTS.lg
    ) {
      document.body.classList.remove("disableScroll");
    }
  }

  burgerMenuHandler() {
    // override of ace-frontend to cancel its tracking layer
    if (this.burgerMenubtn) {
      if (this.burgerMenubtn.getAttribute("aria-expanded") === "false") {
        this.burgerMenubtn.setAttribute("aria-expanded", "true");
        this.closeSubMenuDropdownPanelHanlder();
        this.overlay.classList.add("enableOverlay");
        document.body.classList.add("disableScroll");
      } else {
        this.burgerMenubtn.setAttribute("aria-expanded", "false");
        document.body.classList.remove("disableScroll");
        this.overlay.classList.remove("enableOverlay");
        // this.burgerMenubtn.focus();
      }
      this.toggleModal();
    }
  }
}
// Register the NavBar component with the BaseComponent
CoreJS.BaseComponent.registerComponent(
  HeaderNavigation.CLASS_NAMESPACE,
  MGalleryHeaderNavigation,
  true,
);
